import { useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import logo from "../resources/logo.png";
const DcNav = () => {
  const [showNavItem, setShowNavItem] = useState(false);
  const NavItem = () => {
    return (
      <div
        className="bg-light position-absolute w-100 d-none d-md-block"
        onMouseLeave={() => setShowNavItem(false)}
      >
        <Container className="d-flex justify-content-end pt-2 text-center">
          <div className="me-5">
            <div className="mb-2">
              <a href="/admin/reception/summary" style={{ color: "#6c757d" }}>
                신청 현황
              </a>
            </div>
            <div className="mb-2">
              <a
                href="/admin/reception/receptionist?pageNo=1&rowCount=10"
                style={{ color: "#6c757d" }}
              >
                신청 관리
              </a>
            </div>
            <div className="mb-2">
              <a
                href="/admin/reception/payment?pageNo=1&rowCount=10"
                style={{ color: "#6c757d" }}
              >
                결제 확인
              </a>
            </div>
            <div className="mb-2">
              <a
                href="/admin/reception/application"
                style={{ color: "#6c757d" }}
              >
                대리 접수
              </a>
            </div>
          </div>
          <div className="ms-4 me-5">
            <div className="mb-2">
              <a
                href="/admin/board/notice?pageNo=1"
                style={{ color: "#6c757d" }}
              >
                공지사항
              </a>
            </div>
            <div className="mb-2">
              <a href="/admin/board/qna?pageNo=1" style={{ color: "#6c757d" }}>
                Q&amp;A
              </a>
            </div>
          </div>
          <div className="me-5 ms-4">
            <div className="mb-2">
              <a href="/admin/events/event" style={{ color: "#6c757d" }}>
                기본 정보
              </a>
            </div>
            <div className="mb-2">
              <a href="/admin/events/control" style={{ color: "#6c757d" }}>
                기록 관리
              </a>
            </div>
            <div className="mb-2">
              <a href="/admin/events/record" style={{ color: "#6c757d" }}>
                순위 확정
              </a>
            </div>
            {/* <div className="mb-2">
              <a href="/admin/events/course" style={{ color: '#6c757d' }}>
                코스 관리
              </a>
            </div> */}
          </div>
        </Container>
      </div>
    );
  };
  return (
    <div className="fixed-top noselect">
      <Navbar expand="md" className="pb-0" style={{ backgroundColor: "black" }}>
        <a
          onClick={(e) => {
            e.preventDefault();
            localStorage.removeItem("accessToken");
            window.location.href = "/admin/login";
          }}
          href="/admin/login"
          style={{
            position: "absolute",
            top: "15px",
            right: "20px",
            color: "white",
          }}
        >
          로그아웃
        </a>
        <Container>
          <NavLink to="/" className="navbar-brand">
            <img alt="http://www.dcmarathon.or.kr" src={logo} height={30} />
          </NavLink>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            style={{ border: "none" }}
          />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-end"
          >
            <Nav onMouseEnter={() => setShowNavItem(true)}>
              <NavLink
                className="me-5 text-white"
                to="/admin/reception/summary"
              >
                접수 관리
              </NavLink>
              <NavLink
                className="ms-4 me-5 text-white"
                to="/admin/board/notice?pageNo=1"
              >
                게시판 관리
              </NavLink>
              <NavLink
                className="me-5 ms-4 text-white"
                to="/admin/events/event"
              >
                대회 관리
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {showNavItem && <NavItem />}
    </div>
  );
};
export default DcNav;
